/**
 * 日本の祝日データ（2025〜2030年）
 * 出典：内閣府「国民の祝日について」
 * 収録期間：2025年〜2030年
 * ※振替休日は含む。2027年以降は暫定（天皇誕生日等は確定済み）。
 */

export const JAPANESE_HOLIDAYS = [
  // ── 2025年 ──
  { date: "2025-01-01", name: "元日" },
  { date: "2025-01-13", name: "成人の日" },
  { date: "2025-02-11", name: "建国記念の日" },
  { date: "2025-02-23", name: "天皇誕生日" },
  { date: "2025-02-24", name: "天皇誕生日 振替休日" },
  { date: "2025-03-20", name: "春分の日" },
  { date: "2025-04-29", name: "昭和の日" },
  { date: "2025-05-03", name: "憲法記念日" },
  { date: "2025-05-04", name: "みどりの日" },
  { date: "2025-05-05", name: "こどもの日" },
  { date: "2025-05-06", name: "振替休日" },
  { date: "2025-07-21", name: "海の日" },
  { date: "2025-08-11", name: "山の日" },
  { date: "2025-09-15", name: "敬老の日" },
  { date: "2025-09-23", name: "秋分の日" },
  { date: "2025-10-13", name: "スポーツの日" },
  { date: "2025-11-03", name: "文化の日" },
  { date: "2025-11-23", name: "勤労感謝の日" },
  { date: "2025-11-24", name: "勤労感謝の日 振替休日" },

  // ── 2026年 ──
  { date: "2026-01-01", name: "元日" },
  { date: "2026-01-12", name: "成人の日" },
  { date: "2026-02-11", name: "建国記念の日" },
  { date: "2026-02-23", name: "天皇誕生日" },
  { date: "2026-03-20", name: "春分の日" },
  { date: "2026-04-29", name: "昭和の日" },
  { date: "2026-05-03", name: "憲法記念日" },
  { date: "2026-05-04", name: "みどりの日" },
  { date: "2026-05-05", name: "こどもの日" },
  { date: "2026-05-06", name: "振替休日" },
  { date: "2026-07-20", name: "海の日" },
  { date: "2026-08-11", name: "山の日" },
  { date: "2026-09-21", name: "敬老の日" },
  { date: "2026-09-22", name: "国民の休日" },
  { date: "2026-09-23", name: "秋分の日" },
  { date: "2026-10-12", name: "スポーツの日" },
  { date: "2026-11-03", name: "文化の日" },
  { date: "2026-11-23", name: "勤労感謝の日" },

  // ── 2027年 ──
  { date: "2027-01-01", name: "元日" },
  { date: "2027-01-11", name: "成人の日" },
  { date: "2027-02-11", name: "建国記念の日" },
  { date: "2027-02-23", name: "天皇誕生日" },
  { date: "2027-03-21", name: "春分の日" },
  { date: "2027-03-22", name: "春分の日 振替休日" },
  { date: "2027-04-29", name: "昭和の日" },
  { date: "2027-05-03", name: "憲法記念日" },
  { date: "2027-05-04", name: "みどりの日" },
  { date: "2027-05-05", name: "こどもの日" },
  { date: "2027-07-19", name: "海の日" },
  { date: "2027-08-11", name: "山の日" },
  { date: "2027-09-20", name: "敬老の日" },
  { date: "2027-09-23", name: "秋分の日" },
  { date: "2027-10-11", name: "スポーツの日" },
  { date: "2027-11-03", name: "文化の日" },
  { date: "2027-11-23", name: "勤労感謝の日" },

  // ── 2028年 ──
  { date: "2028-01-01", name: "元日" },
  { date: "2028-01-10", name: "成人の日" },
  { date: "2028-02-11", name: "建国記念の日" },
  { date: "2028-02-23", name: "天皇誕生日" },
  { date: "2028-03-20", name: "春分の日" },
  { date: "2028-04-29", name: "昭和の日" },
  { date: "2028-05-03", name: "憲法記念日" },
  { date: "2028-05-04", name: "みどりの日" },
  { date: "2028-05-05", name: "こどもの日" },
  { date: "2028-07-17", name: "海の日" },
  { date: "2028-08-11", name: "山の日" },
  { date: "2028-09-18", name: "敬老の日" },
  { date: "2028-09-22", name: "秋分の日" },
  { date: "2028-10-09", name: "スポーツの日" },
  { date: "2028-11-03", name: "文化の日" },
  { date: "2028-11-23", name: "勤労感謝の日" },

  // ── 2029年 ──
  { date: "2029-01-01", name: "元日" },
  { date: "2029-01-08", name: "成人の日" },
  { date: "2029-02-11", name: "建国記念の日" },
  { date: "2029-02-12", name: "建国記念の日 振替休日" },
  { date: "2029-02-23", name: "天皇誕生日" },
  { date: "2029-03-20", name: "春分の日" },
  { date: "2029-04-29", name: "昭和の日" },
  { date: "2029-04-30", name: "昭和の日 振替休日" },
  { date: "2029-05-03", name: "憲法記念日" },
  { date: "2029-05-04", name: "みどりの日" },
  { date: "2029-05-05", name: "こどもの日" },
  { date: "2029-07-16", name: "海の日" },
  { date: "2029-08-11", name: "山の日" },
  { date: "2029-08-12", name: "山の日 振替休日" },
  { date: "2029-09-17", name: "敬老の日" },
  { date: "2029-09-23", name: "秋分の日" },
  { date: "2029-10-08", name: "スポーツの日" },
  { date: "2029-11-03", name: "文化の日" },
  { date: "2029-11-23", name: "勤労感謝の日" },

  // ── 2030年 ──
  { date: "2030-01-01", name: "元日" },
  { date: "2030-01-14", name: "成人の日" },
  { date: "2030-02-11", name: "建国記念の日" },
  { date: "2030-02-23", name: "天皇誕生日" },
  { date: "2030-03-20", name: "春分の日" },
  { date: "2030-04-29", name: "昭和の日" },
  { date: "2030-05-03", name: "憲法記念日" },
  { date: "2030-05-04", name: "みどりの日" },
  { date: "2030-05-05", name: "こどもの日" },
  { date: "2030-05-06", name: "振替休日" },
  { date: "2030-07-15", name: "海の日" },
  { date: "2030-08-11", name: "山の日" },
  { date: "2030-08-12", name: "山の日 振替休日" },
  { date: "2030-09-16", name: "敬老の日" },
  { date: "2030-09-23", name: "秋分の日" },
  { date: "2030-10-14", name: "スポーツの日" },
  { date: "2030-11-03", name: "文化の日" },
  { date: "2030-11-04", name: "文化の日 振替休日" },
  { date: "2030-11-23", name: "勤労感謝の日" },
];

/** 指定年の祝日一覧を返す */
export function getHolidaysByYear(year) {
  return JAPANESE_HOLIDAYS.filter(h => h.date.startsWith(String(year) + "-"));
}

/** 収録期間 */
export const HOLIDAY_DATA_RANGE = { from: 2025, to: 2030 };
